import React, { Fragment } from 'react';

import { subscriber_profile_path } from '@routes';
import { FollowUser } from '@utils/backend-api/subscriber_directory';

import OverlayAvatars from '../OverlayAvatars';
import styles from './styles.module.scss';

interface FollowShortHandProps {
  followers: FollowUser[];
  shortHandAvatar: string[];
  totalFollowers: number;
}

const FollowShortHand = ({ totalFollowers, followers, shortHandAvatar }: FollowShortHandProps) => (
  <div className={styles.shortHandFollower}>
    <div className={styles.avatarsContainer}>
      <OverlayAvatars avatars={shortHandAvatar} />
    </div>
    <div className={styles.shortHandNames}>
      <div className={styles.description}>
        Followed By{` `}
        {followers.slice(0, 2).map((follower) => (
          <Fragment key={follower.identityId}>
            <a href={subscriber_profile_path(follower.username)} className={styles.profileLink}>
              {follower.name}
            </a>
            , {` `}
          </Fragment>
        ))}
        {totalFollowers - 2 > 0 ? (
          // we there more than 2 follows after short hand format it should render rest of the string.
          <>
            {``} and {totalFollowers - 2} others.
          </>
        ) : (
          '.'
        )}
      </div>
    </div>
  </div>
);

export default FollowShortHand;
